import React from 'react';
import { Link as SPALink } from '@atlassian/react-resource-router/src/Link.tsx';
import Link from '@atlassian/jira-common-components-link/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

type Props = {
	name: string;
	issuesUrl: string;
};

export default function ComponentView(props: Props) {
	const { name, issuesUrl } = props;

	return fg('components_page_link_spa_transition') ? (
		<SPALink
			href={issuesUrl}
			data-testid="project-directories.components.table.cell.component.link"
		>
			{name}
		</SPALink>
	) : (
		<Link
			// @ts-expect-error - TS2322 - Type '{ children: string; href: string; externalId: string; "data-test-id": string; }' is not assignable to type 'IntrinsicAttributes & Props'.
			href={issuesUrl}
			externalId="project-components.table.name-cell"
			data-testid="project-directories.components.table.cell.component.link"
		>
			{name}
		</Link>
	);
}
